export const formControlOverrides = {
  Label: {
    style: ({ $theme }) => ({
      fontFamily: 'Family/Body',
      fontSize: '16px',
      lineHeight: '160%',
      color: $theme.colors.grey,
    }),
  },
}
